import apiClient from "utils/apiClient";
import { CARE_SERVICE_BASE_URL } from "constants";

const BASE = "/api/v1/efax";

export async function fetchUnprocessedInboundFaxes() {
  const { data } = await apiClient.get(`${BASE}/inbound/unprocessed`, {
    baseURL: CARE_SERVICE_BASE_URL,
  });
  return data;
}

export async function classifyInboundFax(faxId, { isPrescription }) {
  const { data } = await apiClient.post(
    `${BASE}/${faxId}/classify`,
    { isPrescription },
    { baseURL: CARE_SERVICE_BASE_URL }
  );
  return data;
}

export async function fetchInboundFaxReviewQueue() {
  const { data } = await apiClient.get(`${BASE}/review-queue`, {
    baseURL: CARE_SERVICE_BASE_URL,
  });
  return data;
}

export async function retryInboundFax(faxId) {
  const { data } = await apiClient.post(`${BASE}/${faxId}/retry-inbound`, {}, { baseURL: CARE_SERVICE_BASE_URL });
  return data;
}

export async function refreshInboundFaxAttachment(faxId) {
  const { data } = await apiClient.post(`${BASE}/${faxId}/refresh-attachment-url`, {}, { baseURL: CARE_SERVICE_BASE_URL });
  return data;
}


export async function confirmInboundFaxReview(reviewId, { residentId, notes } = {}) {
  const { data } = await apiClient.post(
    `${BASE}/reviews/${reviewId}/confirm`,
    {
      ...(residentId ? { residentId } : {}),
      ...(notes ? { notes } : {}),
    },
    { baseURL: CARE_SERVICE_BASE_URL },
  );
  return data;
}

export async function rejectInboundFaxReview(reviewId, { notes } = {}) {
  const { data } = await apiClient.post(
    `${BASE}/reviews/${reviewId}/reject`,
    notes ? { notes } : {},
    { baseURL: CARE_SERVICE_BASE_URL },
  );
  return data;
}


export async function fetchInboundFaxDocument(reviewId) {
  const { data } = await apiClient.get(`${BASE}/reviews/${reviewId}/document`, {
    baseURL: CARE_SERVICE_BASE_URL,
  });
  return data;
}


export async function searchReviewResidents(reviewId, { name, birthDate } = {}) {
  const { data } = await apiClient.get(`${BASE}/reviews/${reviewId}/candidates`, {
    baseURL: CARE_SERVICE_BASE_URL,
    params: { name, birthDate: birthDate || undefined },
  });
  return data;
}


export async function addInboundFaxReviewCandidate(reviewId, residentId) {
  const { data } = await apiClient.post(
    `${BASE}/reviews/${reviewId}/candidates`,
    { residentId },
    { baseURL: CARE_SERVICE_BASE_URL },
  );
  return data;
}

export async function fetchReviewResidentDetail(reviewId, residentId) {
  const { data } = await apiClient.get(
    `${BASE}/reviews/${reviewId}/residents/${residentId}`,
    { baseURL: CARE_SERVICE_BASE_URL },
  );
  return data;
}
